import { Component, OnInit, Input, Inject, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CalendarioComponent } from '../../../livesHrComponentes/calendario/calendario.component';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-button-menu-item-popup',
  templateUrl: './button-menu-item-popup.component.html',
  styleUrls: ['./button-menu-item-popup.component.scss'],
})
export class ButtonMenuItemPopupComponent implements OnInit {
  @Input() icon;
  @Input() title;
  @Input() path;
  @Input() newButton;
  @Input() sortTitle;

  constructor(
    protected _dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
  ) {

  }

  ngOnInit() {

  }

  getNewEntityPath() {
    return this.path + '/new';
  }

  handleClick(event: Event, sortTitle: string) {
    if (sortTitle === 'CAL') {
      event.preventDefault();
      event.stopPropagation();
      this.onOpenCalendar();
    }
  }

  onOpenCalendar() {
    const dialogRef = this._dialog.open(CalendarioComponent, {
      width: '100%',
      data: { appointments: [], nullData: true, dataFiltered: true }
    });

    const dialogContainer = this.document.querySelectorAll('.mat-dialog-container')[0];
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
      this.renderer.setStyle(dialogContainer, 'max-height', '90vh'); // Limita la altura del popup
      this.renderer.setStyle(dialogContainer, 'overflow-y', 'auto'); // Habilita scroll vertical
      this.renderer.addClass(dialogContainer, 'scrollable-section');
    }

    dialogRef.afterClosed().subscribe(result => {
      // this.getDataSource();
    });
  }

}
